import { Button, Create, CreateButton, Datagrid, DateInput, DeleteButton, EditButton, ExportButton, FilterButton, Link, List, NumberField, ReferenceField, required, SaveButton, SearchInput, TextField, Toolbar, TopToolbar, useNotify, useRecordContext, useRedirect } from 'react-admin';
import { Edit, NumberInput, SimpleForm, TextInput, ReferenceInput, SelectInput } from 'react-admin';
import { getAuthData, url_download_template_sbml } from '../constant/constant';
import Chip from '@mui/material/Chip';
import Alert from '@mui/material/Alert';

let now = new Date().getUTCFullYear();
let tahunArray = [];
for (let index = 2022; index < now+5; index++) {
    let temp = { id: index, name: index };
    tahunArray.push(temp);
}

const sbmlFilters = [
    <SearchInput source="nama_satuan_harga" alwaysOn />,
    <ReferenceInput source="id_wilayah" label="Wilayah" reference="master_kab">
        <SelectInput optionText="nama_kab" />
    </ReferenceInput>,
    <SelectInput source="tahun" choices={tahunArray} />,
    <SelectInput label="Status Waktu Kegiatan" source="is_tanggal_terisi" choices={[
        { id: '0', name: 'Belum Input' },
        { id: '1', name: 'Sudah Input' },
    ]} />
];

const SbmlSaveButton = props => {
    const notify = useNotify();
    const redirect = useRedirect();
    return <SaveButton {...props} type="button" 
        mutationOptions={{
            onSuccess: (response) => {
                notify(`SBML "${response.kegiatan}" created!`);
                redirect('/sbml');
        }}
    } 
    />;
};

const SbmlCreateToolbar = () => (
    <Toolbar>
        <SbmlSaveButton />
        <DeleteButton />
    </Toolbar>
);

const SbmlListActions = () => (
    <TopToolbar>
        <Link to="/sbml/import" style={{textDecoration: "none", display: getAuthData()["role"]=="2"?"none":"inline-flex"}}><Button variant="outlined" label='Import Template'/></Link>
        <a style={{textDecoration: "none", display: getAuthData()["role"]=="2"?"none":"inline-flex"}} href={url_download_template_sbml} download><Button variant="contained" label='Download Template'/></a>
        <FilterButton />
        <CreateButton style={{display: getAuthData()["role"]=="2"?"none":"inline-flex"}} />
        <ExportButton />
    </TopToolbar>
);

const ChipTextField = ({ source }) => {
    const record = useRecordContext();
    console.log("record", record);
    console.log("record source", record[source]);
    return (<Chip variant="outlined" color={(record && record[source])?"success":"error"} label={(record && record[source])?"Sudah Input":"Belum Input"} />);
};

export const SbmlList = () => (
    <List filters={sbmlFilters} actions={<SbmlListActions/>}>
    {/* <List filters={sbmlFilters} > */}
        {/* <Datagrid rowClick="edit"> */}
        <Datagrid>
            <TextField source="id" />
            <TextField source="tahun" />
            <TextField source="nama_satuan_harga" />
            <TextField source="satuan" />
            <NumberField source="honor" />
            <TextField source="kegiatan" />
            <ReferenceField source="id_wilayah" label="Wilayah" reference="master_kab" link={false} >
                <TextField source="nama_kab" />
            </ReferenceField>
            <NumberField source="SBML" />
            <ChipTextField source="is_tanggal_terisi" label="Waktu Kegiatan" />
            <EditButton style={{display: getAuthData()["role"]=="2"?"none":"inline-flex"}} />
        </Datagrid>
    </List>
);

const dateValidation = (value, allValues) => {
    // if (!value) {
    //     return 'The age is required';
    // }
    // if (value < 18) {
    //     return 'Must be over 18';
    // }
    console.log("value", value);
    console.log("allValues", allValues);
    if (allValues["date_end"] < allValues["date_start"]) {
        return 'Tanggal Selesai must be >= Tanggal Mulai';
    }

    // if both var is null then pass
    if((allValues["date_end"] && !allValues["date_start"]) || (!allValues["date_end"] && allValues["date_start"]))  {
        return 'Tanggal Selesai must be >= Tanggal Mulai';
    }

    return undefined;
};

export const SbmlEdit = () => (
    <div>
        <Edit>
            <SimpleForm>
                <NumberInput source="tahun" validate={[required()]}/>
                <TextInput source="nama_satuan_harga" validate={[required()]}/>
                <TextInput source="satuan" validate={[required()]}/>
                <NumberInput source="honor" validate={[required()]}/>
                <TextInput source="kegiatan" multiline validate={[required()]}/>
                <ReferenceInput source="id_wilayah" reference="master_kab">
                    <SelectInput optionText="nama_kab" validate={[required()]}/>
                </ReferenceInput>
                <NumberInput source="SBML" validate={[required()]}/>
                <DateInput source="date_start" />
                <DateInput source="date_end" validate={[dateValidation]} />
            </SimpleForm>
        </Edit>
    </div>
    
);

export const SbmlCreate = () => (
    <div>
        <Create>
            <SimpleForm toolbar={<SbmlCreateToolbar/>}>
                <NumberInput source="tahun" validate={[required()]}/>
                <TextInput source="nama_satuan_harga" validate={[required()]}/>
                <TextInput source="satuan" validate={[required()]}/>
                <NumberInput source="honor" validate={[required()]}/>
                <TextInput source="kegiatan" multiline validate={[required()]}/>
                <ReferenceInput source="id_wilayah" reference="master_kab">
                    <SelectInput optionText="nama_kab" validate={[required()]} />
                </ReferenceInput>
                <NumberInput source="SBML" validate={[required()]} />
            </SimpleForm>
        </Create>
    </div>
    
);